export default __webpack_public_path__ + "static/B0169-260dbcb39601dd523399f7000add1abc.png";